import GroupsPage from "./GroupsPage";

export default GroupsPage;
